import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AccessRightTabs } from '@fi-shared/types';
import { IAccessRightFiltersTab } from '@fi-shared/access-right-filters/access-right-filters';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-access-right-filters-tabs',
    template: `
        @for (tab of accessRightTabs; track tab) {
          <button
            mat-button
            class="fi-access-right-filters-tab"
            type="button"
            [class.BrandedBackgroundColor]="isTabSelected(tab.Id)"
            (click)="selectTab(tab.Id)"
            >
            {{ tab.textId | fiAppText }}
          </button>
        }
        @if (isTooltipShown && isQuickChoiceTabSelected()) {
          <fi-info-icon
            class="static-position"
            [isTooltipShownFormStart]="true"
            [isIconTooltipShown]="false"
            >
            {{ 'no_quick_choice_tooltip1' | fiAppText }} <br /><br />
            {{ 'no_quick_choice_tooltip2' | fiAppText }}
          </fi-info-icon>
        }
        `,
    styleUrls: ['./access-right-filters-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-access-right-filters-tabs' },
    standalone: false,
})
export class AccessRightFiltersTabsComponent {
    @Input() selectedTabId: number;
    @Input() isTooltipShown: boolean = false;
    @Output() selectTabClick = new EventEmitter<number>();

    readonly AccessRightTabsEnum = AccessRightTabs;
    readonly accessRightTabs: IAccessRightFiltersTab[] = [
        {
            Id: this.AccessRightTabsEnum.QuickChoice,
            textId: 'access_rights.quick_selection',
            cssClass: 'tab-quick',
        },
        {
            Id: this.AccessRightTabsEnum.ManualChoice,
            textId: 'access_rights.manual_selection',
            cssClass: 'tab-manual',
        },
    ];

    isQuickChoiceTabSelected(): boolean {
        const quickChoiceTab: IAccessRightFiltersTab = this.accessRightTabs.find((tab: IAccessRightFiltersTab) => {
            return tab.Id === this.AccessRightTabsEnum.QuickChoice;
        });
        return isDefined(quickChoiceTab) ? this.isTabSelected(quickChoiceTab.Id) : false;
    }

    isTabSelected(tabId: number): boolean {
        return this.selectedTabId === tabId;
    }

    selectTab(tabId): void {
        if (this.selectedTabId !== tabId) this.selectTabClick.emit(tabId);
    }
}
